module.exports = __webpack_public_path__ + "static/media/lab.f79f339e.jpg";